module.exports = __webpack_public_path__ + "static/img/cyx-banner.135a784a.png";